import { render, staticRenderFns } from "./BadgeHidden.vue?vue&type=template&id=6e746f72"
import script from "./BadgeHidden.vue?vue&type=script&lang=js"
export * from "./BadgeHidden.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports